import React, { FunctionComponent } from 'react';
import LoadingProgressiveResource from "@/components/responsive/layout/LoadingProgressiveResource";
import IntersectionObserverSSR from "@/components/responsive/layout/IntersectionObserverSSR";
import FlixMedia from "@/components/responsive/product/flixMedia/FlixMedia";
import { AdaptiveLoadingResources } from "@/models/scope/productSheet/AdaptiveLoadingResources";

interface Props {
    soldBy: string,
    adaptiveLoadingResources: AdaptiveLoadingResources,
    labelName: string,
    id: string,
    unitPrice: number,
    description: string
}

export const BrandContent: FunctionComponent<Props> = ({
    soldBy,
    adaptiveLoadingResources,
    unitPrice,
    id,
    labelName,
    description
}) => <LoadingProgressiveResource resourceName={'Ressource2'}
    resources={adaptiveLoadingResources}>
        <IntersectionObserverSSR>
            <div className='enriched-description'>
                <FlixMedia labelName={labelName} id={id} unitPrice={unitPrice} soldBy={soldBy} description={description}/>
            </div>
        </IntersectionObserverSSR>

    </LoadingProgressiveResource>
